import React from 'react';

export default function Instagram() {
  return <></>;
}
